import React, { useState } from 'react';
import styled from 'styled-components';

interface RadioProps {
  id: string;
  fn?: Function;
  label?: string;
  name?: string;
  labelPos?: string;
  disabled?: boolean;
  checked?: boolean;
  value?: any;
  readOnly?: boolean;
}

const RadioWrapper = styled.div`
  display: inline-block;
  height: 20px;
  height: 1.25rem;

  &.right {
    label {
      padding: 0 0 0 1.5rem;
      &::before {
        top: 0.6875rem;
        margin-top: -0.75rem;
      }

      &::after {
        top: 50%;
      }
    }
  }

  &.left {
    label {
      padding: 0 1.5rem 0 0;
      &::before {
        top: 50%;
        left: auto;
        right: 0;
        margin-top: -0.625rem;
      }

      &::after {
        left: auto;
        right: 5px;
      }
    }
  }

  &.up {
    label {
      padding: 0 0 1.5rem 0;
      &::before {
        top: 50%;
        bottom: 0;
        left: 50%;
        margin-left: -0.5625rem;
        margin-top: 0;
      }

      &::after {
        top: 60%;
        bottom: 0;
        left: 50%;
        margin-left: -0.25rem;
        margin-top: 0.0625rem;
      }
    }
  }

  &.down {
    label {
      padding: 1.25rem 0 0 0;
      &::before {
        top: 0;
        left: 50%;
        margin-left: -0.625rem;
        margin-top: 0;
      }

      &::after {
        top: 5px;
        left: 50%;
        margin-left: -0.3125rem;
        margin-top: 0;
        margin-top: 0;
      }
    }
  }
`;

const Lable = styled.label`
  cursor: pointer;
  display: inline-block;
  position: relative;
  padding: 0 0.625rem 0 0.625rem;

  user-select: none;

  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    top: 48%;
    left: 0;
    width: 1.25rem;
    height: 1.25rem;
    margin-top: -10px;
    border: 1px solid #eee;
    text-align: center;
    border-radius: 50%;
  }
  &::after {
    content: '';
    background-color: #ff671d;
    position: absolute;
    top: 50%;
    left: 0.3125rem;
    width: 0.625rem;
    height: 0.625rem;
    border-radius: 50%;
    transform: rotate(-45deg) scale(0);
  }
`;
const Input = styled.input`
  border: 0;
  clip: rect(0 0 0 0);
  width: 1px;
  width: 0.0625rem;
  height: 1px;
  height: 0.0625rem;
  margin: -1px;
  margin: -0.0625rem;
  overflow: hidden;
  padding: 0;
  position: absolute;
  &:focus + label::before {
    border-color: #ff671d;
  }

  //disabled
  &:disabled:focus + label::before {
    border-color: #ff671d;
  }
  &:disabled:checked + label::before {
    border: 1px solid #ccc;
    background: #e6e6e6;
  }
  &:disabled:checked + label::after {
    background: #999;
  }
  &:disabled + label::before {
    border: 1px solid #ccc;
    background: #e6e6e6;
  }
  &:disabled + label::after {
    opacity: 0.5;
  }

  &:checked + label::after {
    /* -webkit-transform: rotate(-45deg) scale(1); */
    -ms-transform: translateY(-50%) rotate(-45deg) scale(1);
    transform: translateY(-50%) rotate(-45deg) scale(1);
    /* -webkit-transition: -webkit-transform 200ms ease-out; */
    transition: -webkit-transform 200ms ease-out;
    -o-transition: transform 200ms ease-out;
    transition: transform 200ms ease-out;
    transition: transform 200ms ease-out, -webkit-transform 200ms ease-out;
  }
  &:checked + label::before {
    border: 2px solid #ff671d;
  }
`;

const Txt = styled.span`
  display: inline-block;
  line-height: 1;
  color: #333;
  font-size: 13px;
  padding-bottom: 2px;
`;

const RadioBox: React.FC<RadioProps> = ({ id, fn, label, name, labelPos, disabled, value = 'all', checked, readOnly }) => {
  const [,] = useState('');
  const [isCheck] = useState(false);
  const AllCheckHandler = e => {
    if (fn) {
      fn(e);
    }
  };

  return (
    <RadioWrapper className={`input-radio ${labelPos}`}>
      <Input
        type="radio"
        disabled={disabled}
        id={id}
        name={name}
        onClick={readOnly ? AllCheckHandler : undefined}
        onChange={!readOnly ? AllCheckHandler : undefined}
        readOnly={readOnly}
        value={value}
        checked={isCheck ? true : checked}
      />
      <Lable htmlFor={id}>
        <Txt>{label}</Txt>
      </Lable>
    </RadioWrapper>
  );
};

export default RadioBox;
